import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { ModalDirective } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';

import { CBMError, ContractSettings } from 'app/models';
import { ComputationMethodType, MeasurementCategoryType } from 'app/models/enums';
import { ContractSettingsService } from 'app/services';
import { enumValues } from 'app/shared/util/enumValues';

@Component({
  selector: 'app-dialog-contract-settings',
  templateUrl: './dialog-contract-settings.component.html',
  styleUrls: ['./dialog-contract-settings.component.scss']
})
export class DialogContractSettingsComponent implements OnInit {
  @ViewChild('contractSettingsDialog') contractSettingsDialog: ModalDirective;

  @Input() contractId: number;

  public contractSettings: ContractSettings = new ContractSettings(
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null
  );
  public computationMethods: any;
  public measurementCategoryTypes: any;
  private newContractSettings = true;

  errorMessages: CBMError[] = [];

  public singleColumnStyle: any = { label: 'col-xs-4', control: 'col-xs-8' };

  constructor(private readonly contractSettingsSerivce: ContractSettingsService) {}

  ngOnInit() {
    this.contractSettings.contractId = this.contractId;
    this.initialiseEnums();
  }

  private initialiseEnums(): void {
    this.computationMethods = enumValues(ComputationMethodType);
    this.measurementCategoryTypes = enumValues(MeasurementCategoryType);
  }

  public show(): void {
    this.contractSettingsDialog.show();
    this.getContractSettings();
  }

  private hide(): void {
    this.contractSettingsDialog.hide();
    this.errorMessages = [];
  }

  private getContractSettings(): void {
    this.contractSettingsSerivce.getContractSettings(this.contractId).subscribe(
      contractSettings => {
        this.newContractSettings = false;
        this.contractSettings = contractSettings;
      },
      error => console.log(error)
    );
  }

  public saveContractSettings(): void {
    this.errorMessages = [];
    let updatedOrCreatedContractSettings: Observable<ContractSettings>;
    if (this.newContractSettings === true) {
      updatedOrCreatedContractSettings = this.contractSettingsSerivce.createContractSettings(this.contractSettings);
    } else {
      updatedOrCreatedContractSettings = this.contractSettingsSerivce.updateContractSettings(this.contractSettings);
    }

    updatedOrCreatedContractSettings.subscribe(
      savedContractSettings => this.hide(),
      (errors: CBMError[]) => {
        console.log(errors);
        this.errorMessages = errors;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/dialog-contract-settings/dialog-contract-settings.component.ts